"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = ['JPMorgan Chase', 'Bank of America', 'Wells Fargo', 'Citigroup', 'U.S. Bank', 'Capital One', 'TD Bank', 'PNC Bank', 'HSBC', 'Citizens Financial Group', 'Fifth Third Bank', 'Comerica', 'USAA', 'Ally Financial', 'Northern Trust', 'KeyBank', 'Sun Trust', 'BBVA Compass', 'Synchrony Bank', 'Charles Schwab', 'BMO Harris', 'Huntington Bank', 'Other'];
exports["default"] = _default;